module.exports = __webpack_public_path__ + "static/media/face-api-demo.5a2fbaf2.jpg";